<script lang="ts">
  export const name = 'Potrait';
  export let className = '';
</script>

<svg class="fill-current stroke-current {className}" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <rect x="60" y="150" width="120" height="100" rx="6.5" transform="rotate(-90 60 157)" fill="none" stroke-width="10" />
</svg>
